import React from "react";
import { INTERACTIVE_CLASSES } from "../../interactive-product-classes";
import { getOpenInNewProps } from "../../links/open-in-new";

export const InteractiveLinkButton = ({
	buttonText = undefined,
	buttonLink = undefined,
	customLinkClass = "",

	onClick = undefined,

	icon = undefined,

	title = undefined,

	stopLinkPropagation = false,

	disabled = undefined,

	linkOpenInNew = false,
}) => {
	const commonProps = {
		className: `${INTERACTIVE_CLASSES.BUTTON} ${customLinkClass}`,
	};

	const content = buttonText ? <p>{buttonText}</p> : null;

	const onLinkClick = stopLinkPropagation
		? (event) => {
				event.stopPropagation();
		  }
		: undefined;

	const openInNewProps = getOpenInNewProps(linkOpenInNew);

	return onClick ? (
		<button
			{...commonProps}
			onClick={onClick}
			title={title}
			disabled={disabled}
		>
			{icon}
			{content}
		</button>
	) : (
		<a
			{...commonProps}
			href={buttonLink}
			{...openInNewProps}
			title={title}
			onClick={onLinkClick}
		>
			{icon}
			{content}
		</a>
	);
};
